import { render, staticRenderFns } from "./TableContatosAdicionados.vue?vue&type=template&id=413d1025&scoped=true&"
import script from "./TableContatosAdicionados.vue?vue&type=script&lang=js&"
export * from "./TableContatosAdicionados.vue?vue&type=script&lang=js&"
import style0 from "./TableContatosAdicionados.vue?vue&type=style&index=0&id=413d1025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d1025",
  null
  
)

export default component.exports